import { Link } from "react-router-dom";
import type { Movie } from "@/lib/types";
import { TYPE_LABELS } from "@/lib/media";

interface MovieCardProps {
  movie: Movie;
  showRating?: boolean;
  showOverview?: boolean;
  compact?: boolean;
}

export default function MovieCard({ movie, showRating = true, showOverview = false, compact = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 focus:outline-none focus:ring-2 focus:ring-primary-400"
      title={`${movie.title} 剧情介绍与演员名单`}
    >
      <div className={`relative w-full overflow-hidden bg-secondary-100 ${compact ? "aspect-[2/3]" : "aspect-[2/3]"}`}>
        <img
          src={movie.poster}
          alt={`《${movie.title}》海报`}
          title={`${movie.title} 影视作品封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/75 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {TYPE_LABELS[movie.type]}
        </span>
        {showRating && (
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-foreground-950">
            <i className="ri-star-fill text-[10px]" />
            {movie.rating.toFixed(1)}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 translate-y-2 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="inline-flex items-center gap-1 rounded-md bg-background-50 px-2 py-1 text-[11px] font-medium text-foreground-950">
            <i className="ri-play-circle-line text-sm" />
            查看详情
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[15px]">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" / ")}
        </p>
        {showOverview && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.tagline}</p>
        )}
      </div>
    </Link>
  );
}